/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import Additives from './pages/Additives';
import Admin from './pages/Admin';
import Analytics from './pages/Analytics';
import Community from './pages/Community';
import Groups from './pages/Groups';
import Home from './pages/Home';
import Manufacturer from './pages/Manufacturer';
import ManufacturerDashboard from './pages/ManufacturerDashboard';
import ProfessionalDashboard from './pages/ProfessionalDashboard';
import ProfessionalProfile from './pages/ProfessionalProfile';
import Profile from './pages/Profile';
import Recipes from './pages/Recipes';
import Rewards from './pages/Rewards';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Additives": Additives,
    "Admin": Admin,
    "Analytics": Analytics,
    "Community": Community,
    "Groups": Groups,
    "Home": Home,
    "Manufacturer": Manufacturer,
    "ManufacturerDashboard": ManufacturerDashboard,
    "ProfessionalDashboard": ProfessionalDashboard,
    "ProfessionalProfile": ProfessionalProfile,
    "Profile": Profile,
    "Recipes": Recipes,
    "Rewards": Rewards,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};